import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import { Text } from '@instructure/ui-text';
import { ProgressBar } from '@instructure/ui-progress';
import t from 'format-message';
import { withStyle, jsx } from '@instructure/emotion';
import { outcomeResultShape, scoringMethodShape, stylesShape } from "../../../store/shapes.js";
import convertToPoints from "../convertToPoints.js";
import generateComponentTheme from "../../theme.js";
import generateStyle from "./styles.js";
var MasteryCounts = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(MasteryCounts, _React$Component);
  var _super = _createSuper(MasteryCounts);
  function MasteryCounts() {
    _classCallCheck(this, MasteryCounts);
    return _super.apply(this, arguments);
  }
  _createClass(MasteryCounts, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        outcomeResult = _this$props.outcomeResult,
        scoringMethod = _this$props.scoringMethod;
      var masteryPoints = convertToPoints(scoringMethod.mastery_percent, scoringMethod);
      return jsx("div", null, jsx("div", {
        css: this.props.styles.masteryScoreSection
      }, jsx("div", {
        css: this.props.styles.masteryScoreBoxAboveMastery
      }, jsx(Text, {
        size: "x-large"
      }, outcomeResult.masteryCount), jsx(Text, {
        size: "small"
      }, t('Mastery at {mastery} pts', {
        mastery: masteryPoints
      }))), jsx("div", {
        css: this.props.styles.masteryScoreBoxBelowMastery
      }, jsx(Text, {
        size: "x-large"
      }, outcomeResult.count - outcomeResult.masteryCount), jsx(Text, {
        size: "small"
      }, t("Didn't Meet")))), jsx("div", {
        css: this.props.styles.masteryBarGraph,
        "data-automation": "outcomeView__masteryBarGraph"
      }, jsx(ProgressBar, {
        size: "small",
        screenReaderLabel: t('{count} of {total} met mastery', {
          count: outcomeResult.masteryCount,
          total: outcomeResult.count
        }),
        meterColor: "success",
        valueMax: outcomeResult.count,
        valueNow: outcomeResult.masteryCount
      }), jsx("div", {
        css: this.props.styles.masteryBarDetails,
        "data-automation": "outcomeView__masteryBarDetails"
      }, jsx("div", {
        css: this.props.styles.masteryCountText
      }, jsx(Text, {
        size: "small",
        "data-automation": "outcomeView__masteryCount"
      }, t('{count} Mastery at {mastery} pts', {
        count: outcomeResult.masteryCount,
        mastery: masteryPoints
      }))), jsx(Text, {
        size: "small",
        "data-automation": "outcomeView__noMasteryCount"
      }, t("{count} Didn't Meet", {
        count: outcomeResult.count - outcomeResult.masteryCount
      })))));
    }
  }]);
  MasteryCounts.displayName = "MasteryCounts";
  return MasteryCounts;
}(React.Component), _class2.propTypes = {
  outcomeResult: outcomeResultShape.isRequired,
  scoringMethod: scoringMethodShape.isRequired,
  styles: stylesShape
}, _class2)) || _class);
export { MasteryCounts as default };